import React from 'react';
import { useSelector } from 'react-redux';
import Modal from '@saucelabs/ds-modal';
import { modalConnectV2 } from '@saucelabs/sl-container-modal';
import { Typography } from '@saucelabs/ds-typography';
import { NoData } from '@saucelabs/ds-data-states';

import constants from '../constants';
import selectors from '../selectors';
import UploadFileButton from './UploadFileButton';
import UploadToSdCardFilesList from './UploadToSdCardFilesList';
import UploadToSdCardFilesSearch from './UploadToSdCardFilesSearch';

const UploadFileToSdCardModal: React.FC = () => {
  const { files, searchTerm } = useSelector(selectors.uploadToSdCardSelector);

  return (
    <Modal
      actionButtonProps={{ className: 'hidden' }} // action/hide buttons are rendered only together
      hideButtonProps={{ children: 'Close' }}
      onConfirm={() => { /* needed to render modal buttons at all */ }}
      size="large"
      title="Upload a File to SD Card"
    >
      {(files.length === 0 && !searchTerm) && (
        <div
          className="h-50 w-full flex flex-col items-center justify-center gap-y-2"
          data-qa="upload-to-sd-card-empty"
        >
          <Typography variant="body-large">
            No files available. Choose a file to add to your uploads.
          </Typography>

          <UploadFileButton />
        </div>
      )}

      {(files.length > 0 || searchTerm) && (
        <div className="flex justify-between mt-1 mb-2.5">
          <UploadToSdCardFilesSearch />
          <UploadFileButton />
        </div>
      )}

      {(files.length === 0 && searchTerm) && (
        <NoData
          className="mx-auto"
          spacing="large"
        />
      )}

      {(files.length > 0) && (
        <UploadToSdCardFilesList />
      )}
    </Modal>
  );
};

UploadFileToSdCardModal.displayName = 'UploadFileToSdCardModal';

export default (modalConnectV2(constants.MODAL_KEY, UploadFileToSdCardModal));
